import React from 'react';

type AudioLevelContextState = {
    audioLevel: number,
    setAudioLevel: (valume: number) => void
}
const AudioLevelContext = React.createContext<AudioLevelContextState | {}>({});

export default AudioLevelContext;